import { FONT_SIZES } from '../constants/theme'

export const toggleFontSize = (updateGui, size, location) => {
  const htmlTag = document.querySelector('html')
  if (!htmlTag) {
    return
  }
  const fontSize = size >= FONT_SIZES.length ? 0 : size
  htmlTag.style.fontSize = FONT_SIZES[fontSize].size
  if (location && (window as any).analytics) {
    ;(window as any).analytics.track('product_font_size_change', {
      location,
      size,
    })
  }
  return updateGui({
    variables: {
      input: { fontSize },
    },
  })
}

export const toggleHighContrast = (
  updateGui,
  setTheme,
  isHighContrast,
  location,
) => {
  const updatedContrast = !isHighContrast
  setTheme(updatedContrast)
  if ((window as any).analytics) {
    ;(window as any).analytics.track('product_contrast_change', {
      location,
    })
  }
  return updateGui({
    variables: {
      input: { isHighContrast: updatedContrast },
    },
  })
}
